import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticsService, APP_SETTINGS, ToastConfigService, UtilityService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { ValidationUtils } from 'src/app/shared/utils/validation.utils';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NgIf, NgStyle } from '@angular/common';
import { IMaskDirective } from 'angular-imask';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        ReactiveFormsModule,
        IMaskDirective,
        NgStyle,
    ],
})
export class SignupComponent implements OnInit, OnDestroy {

  public screenWidth: number;

  public firstName = new UntypedFormControl('', [Validators.required]);
  public lastName = new UntypedFormControl('', [Validators.required]);
  // public companyName = new FormControl('', [Validators.required]);
  public companyName = new UntypedFormControl('', []);
  public address1 = new UntypedFormControl('', [Validators.required]);
  public address2 = new UntypedFormControl('');
  public city = new UntypedFormControl('', [Validators.required]);
  public state = new UntypedFormControl('', [Validators.required]);
  public zipCode = new UntypedFormControl('', [Validators.required]);
  public phone = new UntypedFormControl('', [Validators.required]);
  public password = new UntypedFormControl('', [Validators.required]);
  public confirmPassword = new UntypedFormControl('', [Validators.required]);
  public qID = new UntypedFormControl('', Validators.compose([Validators.required, Validators.pattern(ValidationUtils.qIDPattern)]));
  public email = new UntypedFormControl('', [Validators.required, Validators.pattern(ValidationUtils.emailPattern)]);
  public reEnterEmail = new UntypedFormControl('', [Validators.required, Validators.pattern(ValidationUtils.emailPattern)]);
  public user: any;
  private subscription: ISubscription[];
  public errorMessage = '';

  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;
  public show = false;
  APP_SETTINGS: any;
  private colors = ['#F00', '#0F0', '#0F0'];

  private impermissible_prefixes = [
    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
    'appl', 'ibm', 'pass', 'ros', 'asdf', 'sign', 'basic', 'log', 'sys', 'cadam',
    'test', 'tso', 'demo', 'net', 'valid', 'new', 'vtam', 'focus', 'xxx', 'game',
    '1234', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', 'bmw', 'mai', 'dez',
    'mae', 'okt', 'cad', 'catia', 'bm1ramf', 'beit08a', 'am07cu4', '19mond6'
  ];
  private isBMW: boolean = false;
  private isMINI: boolean = false;
  private isROLLSROYCE: boolean = false;

  // public userForm = new FormGroup({});
  public userForm = this.fb.group({
    firstName: this.firstName,
    lastName: this.lastName,
    companyName: this.companyName,
    address1: this.address1,
    address2: this.address2,
    city: this.city,
    state: this.state,
    phone: this.phone,
    zipCode: this.zipCode,
    email: this.email,
    qID: this.qID,
    password: this.password,
    confirmPassword: this.confirmPassword,
    reEnterEmail: this.reEnterEmail,
    isBMW: APP_SETTINGS.isBMW,
    isMINI: APP_SETTINGS.isMINI,
    isROLLSROYCE: APP_SETTINGS.isRollsRoyce
  });
  public phoneMaks= {mask: '(000) 000-0000'};

  constructor(private fb: UntypedFormBuilder,
    private toastService: ToastConfigService,
    private userProfileService: UserProfileService,
    private router: Router,
    private analyticsService: AnalyticsService,
    private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.subscription = [];
  }
  private measureStrength(p) {
    let force = 0;
    const regex = /(\#|\$)/g;

    const lowerLetters = /[a-z]+/.test(p);
    const numbers = p.match(/[0-9]/g) ? p.match(/[0-9]/g).length < 5 : false;
    const symbols = regex.test(p);

    const flags = [lowerLetters, numbers, symbols];

    let passedMatches = 0;
    for (let flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
    force += passedMatches * 10;

    // penality (short password)
    force = (p.length <= 7) ? Math.min(force, 10) : force;

    // penalty for impermissible prefixes
    //force = this.impermissible_prefixes.find(prefix => p.substr(0, prefix.length).includes(prefix)) ? Math.min(force, 10) : force;

    // penality (poor variety of characters)
    force = (passedMatches <= 2) ? Math.min(force, 10) : force;

    return force;

  }
  private getColor(s) {
    let idx = 0;
    if (s <= 10) {
      idx = 0;
    } else {
      idx = 2;
    }
    return {
      idx: idx + 1,
      col: this.colors[idx]
    };
  }

  checkPasswordStrength() {
    const password = this.userForm.controls.password.value;
    this.setBarColors(3, '#DDD');
    if (password) {
      const c = this.getColor(this.measureStrength(password));
      this.setBarColors(c.idx, c.col);
      return c.idx;
    }
  }
  private setBarColors(count, col) {
    for (let _n = 0; _n < count; _n++) {
      this['bar' + _n] = col;
    }
  }
  onSubmit() {
    if (this.userForm.controls.qID.value.length < 8 || this.userForm.controls.qID.value.length > 60) {
      return alert("User name does not meet the required length. It should be between 8 and 60 charaters.");
    }

    if (this.userForm.controls.password.value != this.userForm.controls.confirmPassword.value) {
      return alert("Password and confirm password are not matching..");
    }
    if (this.userForm.controls.email.value != this.userForm.controls.reEnterEmail.value) {
      return alert("Email and Re-Enter Email both are not matching..");
    }
    if (this.isBMW == true) {
      this.analyticCallAddUpdateUser(this.userForm.controls.qID.value, this.userForm.controls.address1.value, this.userForm.controls.city.value,
        this.userForm.controls.state.value, "BMW");
    }
    else if (this.isMINI == true) {
      this.analyticCallAddUpdateUser(this.userForm.controls.qID.value, this.userForm.controls.address1.value, this.userForm.controls.city.value,
        this.userForm.controls.state.value, "MINI");
    }
    // else if (this.isRollsRoyce == true) {
    // this.analyticCallAddUpdateUser(this.userForm.controls.qID.value, this.userForm.controls.address1.value, this.userForm.controls.city.value,
    // this.userForm.controls.state.value, "ROLLSROYCE");
    // }
    this.subscription.push(this.userProfileService.createNewUser(this.userForm.value).subscribe(data => {
      if (data) {
        this.toastService.popToast('Account created');
        this.errorMessage = '';
        this.userForm.reset();
        setTimeout(() => {
          this.router.navigateByUrl('login');
        }, 2000);
      }
    },
      error => {
        this.errorMessage = error.error.message;
      }));



  }

  removeSpaces(control: AbstractControl) {
    if (control && control.value && !control.value.replace(/\s/g, '').length) {
      control.setValue('');
    }
    return null;
  }

  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

  analyticCallAddUpdateUser(userId: string, Address1: string, city: string, state: string, brandName: string) {
    this.analyticsService.trackNewThirdPartyUserAdded(userId, Address1, city, state, brandName)
  }
}
